<template>
    <div class="module-info sip-view-empty" role="region">
        <div v-if="icon" class="module-info__icon-wrap" aria-hidden="true">
            <i :class="['fa', 'fa-' + icon]"></i>
        </div>
        <h4 v-if="title" class="module-info__title">{{ trans(module + '.' + title) }}</h4>
        <p v-if="description" class="module-info__desc">{{ trans(module + '.' + description) }}</p>
        <slot name="btn"></slot>
    </div>
</template>

<script>
    export default {
        props: ['module', 'icon', 'title', 'description'],
    };
</script>
